import { Title } from "@angular/platform-browser";
import { Http } from "@angular/http";
import { ConfigsService } from "./../configs.service";
import { AutenticaService } from "./autentica.service";
import { Component, OnInit, AfterViewInit } from "@angular/core";
declare var swal;
declare var $;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit, AfterViewInit {
  logo: string;
  corPadrao: string;
  loginUsr: boolean = true;
  loginHosp: boolean = false;
  dataAtual: any = new Date();
  anoAtual: any = this.dataAtual.getFullYear();

  constructor(
    private app: ConfigsService,
    private autentica: AutenticaService,
    private titulo: Title,
    private http: Http
  ) {
    this.titulo.setTitle("Login - " + this.app.nome);
    this.logo = app.logo;
    this.corPadrao = app.corPadrao;
  }

  ngOnInit() {}

  ngAfterViewInit() {
    $("input[name=loginUsr]").focus();
  }

  listaHosp: any;
  dadosUsuario: any;
  dadosHospital: any = [];

  capturaDados(form) {
    $.bloqueiaTela();
    this.http
      .get(
        `${this.app.urlApi}/medicos/usr/${form.value.loginUsr}/pw/${form.value.senhaUsr}`
      )
      .subscribe((data) => {
        var dados = data.json();
        dados = dados.dados;
        data = data.json();
        $.desbloqueiaTela();
        console.log(data);
        if (data.status == 1) {
          this.dadosUsuario = dados;
          this.trazHospitais();
          this.loginHosp = true;
          this.loginUsr = false;
        } else {
          swal("Oops", "Login ou Senha Incorretos", "info");
        }
      });
  }
  retornoHospitalMsg: string = "";
  trazHospitais() {
    // console.log(this.dadosUsuario.codigo);
    this.http
      .get(
        `${this.app.urlApi}/medicos/hospitais/medico/${this.dadosUsuario.codigo}`
      )
      .subscribe((dataH) => {
        if (dataH.json().cod_hospital) {
          this.listaHosp = Array(dataH.json());
        } else {
          this.listaHosp = dataH.json();
        }

        if (this.listaHosp <= 0) {
          this.retornoHospitalMsg =
            "Não há hospitais vinculados à este médico.";
        }
      });
  }
  selecionaHospital(hospital) {
    this.listaHosp.forEach((e) => {
      if (e.cod_hospital == hospital.value) {
        this.dadosHospital = e;
      }
    });
  }

  fazerLogin() {
    this.autentica.fazerLogin(1, this.dadosUsuario, this.dadosHospital);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts